<form class="d-flex flex-column flex-fill h-100" [formGroup]="form" *transloco="let t">
    <div class="d-flex flex-column flex-shrink-0">
        <h1 mat-dialog-title class="text-truncate flex-shrink-0">
            <ng-container *ngIf="!success">{{ t('place-offer-form.title', { name: offer.domain?.name }) }}</ng-container>
            <ng-container *ngIf="success">{{ t('place-offer-form.success-title', { name: offer.domain?.name }) }}</ng-container>
        </h1>
        <td-operation-status class="w-100" [operation]="operation" (done)="operationDone($event)" #op></td-operation-status>
    </div>
    <mat-dialog-content class="d-flex flex-column flex-grow-1">
        <div class="d-flex flex-column gap-2" *ngIf="!success">
            <td-money-input class="mt-2" [control]="form.get('price')!" [label]="t('fields.price')"></td-money-input>
            <mat-form-field appearance="standard">
                <mat-label>{{ t('fields.offer-expiration') }}</mat-label>
                <input formControlName="expiration" type="number" matInput />
                <span matSuffix>{{ t('general.days') }}</span>
                <mat-error>
                    <td-validation-messages [control]="form.get('expiration')!" [context]="{ name: t('fields.offer-expiration') }"></td-validation-messages>
                </mat-error>
            </mat-form-field>
            <div [tdDynamicHtml]="t('place-offer-form.fee-info')"></div>
            <div [tdDynamicHtml]="t('place-offer-form.notes', { name: offer.domain?.name })"></div>
        </div>
        <div class="d-flex flex-column align-items-center gap-2" *ngIf="success">
            <td-share class="mt-4 pt-4" [text]="t('place-offer-form.share-text', { name: offer.domain!.name })" [domainName]="offer.domain!.name"></td-share>
        </div>
    </mat-dialog-content>
    <mat-dialog-actions class="d-flex justify-content-end align-items-end w-100 min-height-auto">
        <ng-container *ngIf="!success">
            <button mat-flat-button color="primary" (click)="save()" [disabled]="form.invalid || op.inProgress">
                {{ t('actions.publish-for-sale') }}
            </button>
            <button mat-button (click)="cancel()" [disabled]="op.inProgress">{{ t('actions.cancel') }}</button>
        </ng-container>
        <ng-container *ngIf="success">
            <button mat-flat-button color="primary" (click)="continue()">{{ t('actions.continue') }}</button>
        </ng-container>
    </mat-dialog-actions>
</form>
